export const MEDIUM = Object.freeze({
    EMAIL: 'email',
    SMS: 'sms'
  })
  